/* global __AGROEL_BUNDLE_RELEASE_META__ */

function compiledBuildMeta () {
  try {
    const value = __AGROEL_BUNDLE_RELEASE_META__
    return value && typeof value === 'object' ? value : {}
  } catch (error) {
    void error
    return {}
  }
}

export const BUILD_META = Object.freeze({ ...compiledBuildMeta() })
export const BUNDLE_BUILD_META = BUILD_META
export const APP_VERSION = String(BUILD_META.release_version || BUILD_META.version || 'unknown')
export const RELEASE_VERSION = APP_VERSION
export const SOURCE_VERSION = String(BUILD_META.source_version || '')
export const DEPLOY_NUMBER = BUILD_META.deploy_number !== null &&
  BUILD_META.deploy_number !== undefined &&
  Number.isSafeInteger(Number(BUILD_META.deploy_number))
  ? Number(BUILD_META.deploy_number)
  : null
export const AUTH_EPOCH = Math.max(1, Number(BUILD_META.auth_epoch || 1) || 1)
export const PWA_PROTOCOL_EPOCH = Math.max(1, Number(BUILD_META.pwa_protocol_epoch || 1) || 1)
export const DEXIE_SCHEMA_VERSION = Math.max(1, Number(BUILD_META.dexie_schema_version || 1) || 1)
export const BUILD_TIME_UTC = String(BUILD_META.build_time_utc || '')
export const GIT_COMMIT = String(BUILD_META.frontend_commit || '')

export default BUILD_META
